import { useState } from "react"

import { useEvent } from "shared/lib/useEvent"

export function useInputDescriptionManager() {
  const [descriptions, setDescriptions] = useState<string[]>([])

  const registerDescription = useEvent((id: string) => {
    setDescriptions(prev => {
      if (prev.includes(id)) return prev
      return [...prev, id]
    })
  })

  const unregisterDescription = useEvent((id: string) => {
    setDescriptions(prev => prev.filter(descID => descID !== id))
  })

  return {
    descriptionIDs: descriptions,
    registerDescription,
    unregisterDescription
  }
}
